import { render, staticRenderFns } from "./FancyButton.vue?vue&type=template&id=baec43cc&scoped=true&"
import script from "./FancyButton.vue?vue&type=script&lang=js&"
export * from "./FancyButton.vue?vue&type=script&lang=js&"
import style0 from "./FancyButton.vue?vue&type=style&index=0&id=baec43cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baec43cc",
  null
  
)

export default component.exports